export const CREATE_QUANTITYIMPORT_REQUEST = 'CREATE_QUANTITYIMPORT_REQUEST';
export const CREATE_QUANTITYIMPORT_SUCCESS = 'CREATE_QUANTITYIMPORT_SUCCESS';
export const CREATE_QUANTITYIMPORT_FAILURE = 'CREATE_QUANTITYIMPORT_FAILURE';
export const LOOKUP_QUANTITYIMPORT_REQUEST = 'LOOKUP_QUANTITYIMPORT_REQUEST';
export const LOOKUP_QUANTITYIMPORT_SUCCESS = 'LOOKUP_QUANTITYIMPORT_SUCCESS';
export const LOOKUP_QUANTITYIMPORT_FAILURE = 'LOOKUP_QUANTITYIMPORT_FAILURE';
export const QUANTITYIMPORT_RESET = 'QUANTITYIMPORT_RESET';
